import { render, staticRenderFns } from "./OrganizationResourcesPane.vue?vue&type=template&id=e7951b6a&"
import script from "./OrganizationResourcesPane.vue?vue&type=script&lang=ts&"
export * from "./OrganizationResourcesPane.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationResourcesPane.vue?vue&type=style&index=0&id=e7951b6a&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7951b6a')) {
      api.createRecord('e7951b6a', component.options)
    } else {
      api.reload('e7951b6a', component.options)
    }
    module.hot.accept("./OrganizationResourcesPane.vue?vue&type=template&id=e7951b6a&", function () {
      api.rerender('e7951b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/OrganizationResourcesPane.vue"
export default component.exports